<div class="module-list shopping-list" *ngIf="customerIsActive">
  <nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
  <div class="shopping-list-container" *ngIf="!isLoading && showTable">
    <nz-empty *ngIf="data.length === 0" [nzNotFoundImage]="'../../../assets/empty_Shopping_Cart.svg'"
      [nzNotFoundContent]="contentTpl" [nzNotFoundFooter]="footerTpl">
      <ng-template #contentTpl>
        <h3>
          {{ "Your shopping list is empty" | locale }}
        </h3>
      </ng-template>
      <ng-template #footerTpl>
        <button nz-button nzType="primary" (click)="createShoppingList()">
          {{ "Create New Shopping List" | locale }}
        </button>
      </ng-template>
    </nz-empty>
    <div class="site-page-header-ghost-wrapper">
      <nz-page-header [nzGhost]="false" *ngIf="data.length != 0">
        <nz-page-header-title>{{
          "Existing Shopping Lists" | locale
          }}</nz-page-header-title>
        <nz-page-header-extra>
          <button nz-button nzType="primary" (click)="createShoppingList()">
            {{ "Create New Shopping List" | locale }}
          </button>
        </nz-page-header-extra>
      </nz-page-header>
      <div class="shopping-list-table" *ngIf="data.length > 0">
        <nz-table [nzLoading]="tableLoading" #dataTable [nzData]="this.data" [nzBordered]="true"
          [nzFrontPagination]="false">
          <thead>
            <tr *ngIf="section != null">
              <ng-container *ngFor="let field of section.ColumnSettingsParsed">
                <th *ngIf="field.Visible">
                  {{ field.Title | locale }}
                </th>
              </ng-container>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr>
          {{
            data | json
          }}
        </tr> -->
            <ng-container>
              <tr *ngFor="let row of data">
                <ng-container *ngFor="let column of section.ColumnSettingsParsed">
                  <td *ngIf="column.Visible" [ngStyle]="{
                    width: 100 / section.ColumnSettingsParsed.length + '%'
                  }">
                    {{ row[column.Name] }}
                    <span *ngIf="column.Name == 'TotalLines'">{{
                      row.DocCur
                      }}</span>
                  </td>
                </ng-container>
                <td>
                  <nz-space>
                    <nz-space-item *ngIf="row.ActionVisible == 'true'">
                      <button nz-button nzType="default" (click)="continueShopping(row.DocEntry)">
                        {{ "Continue Shopping" | locale }}
                      </button>
                    </nz-space-item>
                    <nz-space-item *ngIf="row.ActionVisible == 'true'">
                      <button nz-button nzType="default" nzDanger
                        [nzPopconfirmTitle]="'Are you sure you want to permanently delete this shopping list?' | locale"
                        (nzOnConfirm)="deleteShoppingList(row.DocEntry)" nz-popconfirm>
                        {{ "Delete" | locale }}
                      </button>
                    </nz-space-item>
                  </nz-space>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!showTable">
    <nz-affix [nzOffsetTop]="0" [nzTarget]="'#shopping-list-header'">
      <nz-page-header class="page-header" (nzBack)="backButtonClicked()" nzBackIcon [nzTitle]="
          mode == 'add'
            ? ('Create New Shopping List' | locale)
            : ('Edit Shopping List' | locale)
        "></nz-page-header>
    </nz-affix>
    <div class="record-page-container" *ngIf="mode == 'add'">
      <app-record-page [actionType]="'add'" [inDrawer]="true" [footerAtTop]="true" [moduleId]="docType"
        [(recordModel)]="recordModel" (backButtonClicked)="backButtonClicked()"
        (objectSubmitted)="linkedObjectSubmitted($event)">
      </app-record-page>
    </div>
    <!-- <div class="record-page-container" *ngIf="mode == 'edit'">
      <app-record-page
        [actionType]="'edit'"
        [inDrawer]="true"
        [(recordModel)]="recordModel"
        [fromDraft]="true"
        [footerAtTop]="true"
        [moduleId]="docType"
        [recordId]="recordId"
        (backButtonClicked)="backButtonClicked()"
        (objectSubmitted)="linkedObjectSubmitted($event)"
      >
      </app-record-page>
    </div> -->
    <div class="record-page-container" *ngIf="mode == 'edit'">
      <app-record-page [actionType]="'edit'" [inDrawer]="true" [(recordModel)]="recordModel" [footerAtTop]="true"
        [moduleId]="docType" [recordId]="recordId" (backButtonClicked)="backButtonClicked()"
        (objectSubmitted)="linkedObjectSubmitted($event)">
      </app-record-page>
    </div>
  </ng-container>
</div>
<div class="module-list shopping-list" *ngIf="!customerIsActive">
  <div class="shopping-list-container" *ngIf="!isLoading && showTable">
    <nz-empty [nzNotFoundContent]="contentTpl">
      <ng-template #contentTpl>
        <h3 [innerHtml]="onHoldMsg | safeHtml">
        </h3>
      </ng-template>
    </nz-empty>
  </div>
</div>
